import styled from '@emotion/styled'
import { withClass } from '@news-mono/web-common'
import { breakpoint } from '../../../../__styling/style-functions/breakpoint'
import { colorsPN } from '@news-mono/design-tokens'
import { calcRem } from '../../../../__styling'
import React from 'react'

export const pnVideoClassname = 'pn-video-specificity'
interface StyledVideoProps {
    posterImage?: string
    isStickyVideo?: boolean
}

const { background } = colorsPN

export const StyledWrapper = styled('div')({
    position: 'relative',
    display: 'block',
})

export const StyledPNVideo = withClass(pnVideoClassname)(
    styled('div')<StyledVideoProps>(
        {
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            backgroundColor: background.strong,

            padding: '0 0 56.25%',
            minHeight: '80px',

            position: 'relative',
            overflow: 'hidden',
            [breakpoint('sm')]: {
                minHeight: '140px',
            },
            '.collection__card-media > &': {
                padding: 'auto',
                minHeight: 'unset',

                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                overflow: 'hidden',
            },
        },
        (props) => ({
            backgroundImage: props.posterImage && `url(${props.posterImage})`,
            borderRadius: props.isStickyVideo ? '8px' : undefined,
        }),
        {
            // the video className is added before the contextual selector to ensure specificity in ie10
            [`&.${pnVideoClassname} .vjs-big-play-button`]: {
                display: 'none',
            },

            [`&.${pnVideoClassname} .vjs-big-play-button .vjs-control-text`]: {
                position: 'relative',
                overflow: 'visible',
                clip: 'auto',
                margin: 0,
                padding: 0,
                border: 0,
                display: 'none',
            },
        },
    ),
)
StyledPNVideo.displayName = 'StyledPNVideo'

export const StyledStickyVideoCloseButton = styled('div')({
    marginLeft: 'auto',
    marginBottom: calcRem(8),
    width: 40,
    height: 40,

    right: 0,
    borderRadius: calcRem(72),
    background: colorsPN.fill.strong,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
        background: colorsPN.text.secondary,
        cursor: 'pointer',
    },
})

export const StyledStickyCloseX = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M18 6L6 18M6 6L18 18"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
